import axios from 'axios';

const contentClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 8000,
});

export const getPublicPage = async (slug) => {
  const response = await contentClient.get(`/api/content/pages/${slug}`);
  return response.data;
};

export const getMarketAnalysisPosts = async () => {
  const response = await contentClient.get('/api/content/market-analysis-posts');
  return response.data;
};

export const checkBackendHealth = async () => {
  await contentClient.get('/api/content/pages/global-layout');
};
